import Axios from 'middleware/axiosInstance'
import React, { useEffect, useState } from 'react'
import { Button, Space, Table } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import Loading from 'layouts/Loading/Loading';

function SocialMedia() {
  const navigate = useNavigate();

  const [allSocialMedia, setAllSocialMedia] = useState(null)
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  const getAllSocialMedia = () => {
    Axios.get("/social-media")
      .then((res) => {
        setAllSocialMedia(res.data)
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    getAllSocialMedia()
  }, []);


  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const deleteDoc = (socialMedia) => {
    if (window.confirm(`آیا "${socialMedia.name}" حذف گردد؟`)) {
      deleteDocHandler(socialMedia);
    }
  };

  const deleteDocHandler = (socialMedia) => {
    Axios.delete(`social-media/${socialMedia.id}`)
      .then((res) => {
        if (res.status === 204) {
          console.log(res);
        }
        getAllSocialMedia()
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
      });
  };
  const goToAddPage = () => {
    navigate("/social-media/add")
  }

  const goToSortingPage = () => {
    navigate("/social-media/sorting")
  }

  const columns = [
    {
      title: "نام",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
      sortOrder: sortedInfo.columnKey === "name" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "لینک شبکه اجتماعی",
      dataIndex: "address",
      key: "address",
      sorter: (a, b) =>
        a.address > b.address ? 1 : b.address > a.address ? -1 : 0,
      sortOrder: sortedInfo.columnKey === "address" ? sortedInfo.order : null,
      ellipsis: true,
      render: (text) => (
        <a href={text} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff' }}>
          {text}
        </a>
      ),
    },
    {
      title: "وضعیت نمایش در سایت",
      dataIndex: "is_visible",
      key: "is_visible",
      render: (text) => (
        <span>{text ? "✔" : "✗"}</span>
      ),
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      render: (a, socialMedia) => (
        <Space size="small">
          <Link
            to={`/social-media/edit/${socialMedia.id}`}
            className="btn btn-primary btn-sm"
          >ویرایش</Link>
          <button
            onClick={() => deleteDoc(socialMedia)}
            className="btn btn-danger btn-sm"
          >حذف</button>
        </Space>
      ),
    },
  ];
  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <Space
          style={{
            marginBottom: 16,
          }}
        >
          <Button disabled={true} onClick={goToAddPage}>اضافه کردن</Button>
          <Button 
            onClick={goToSortingPage}
          >
            مرتب‌سازی و ترتیب‌بندی
          </Button>
        </Space>
        <div>
          {allSocialMedia ?
            allSocialMedia[0] ?
              <Table
                pagination={false}
                columns={columns}
                dataSource={allSocialMedia}
                rowKey="id"
                onChange={handleChange}
              />
              : <h2>محتوایی نیست</h2> : <Loading />}
        </div>
      </div>
    </div>
  );
}
export default SocialMedia

